import React, {useState, useEffect, Fragment} from "react";
import Layout from "components/sales/layout/layout";
import DivLayout from "../../../../../components/sales/divLayout/divLayout";
import {accountPennyDropRequest} from "../../../../../services/redux/CarLoan/action";
import {toast} from "react-toastify";

const PennyDropAccount = ({
                            match,
                            loanAccountRequest,
                            loanAccountResponse = [],
                              accountPennyDropRequest,
                              accountPennyDropResponse = []
                        }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [inputList, setInputList] = useState([]);
    const [stage, setStage] = useState(1);
    const [primary, setPrimaryName] = useState({name: '', bank_account_name:''});
    const [coApplicant, setcoApplicantName] = useState({name: '', bank_account_name:''});

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await loanAccountRequest(match?.params?.id)
            setIsLoading(false)
        })()
    }, [])

    const handlePennyDrop = async (e, accountId, accountType) => {
        e.preventDefault()
        setIsLoading(true)
        let res = await accountPennyDropRequest({account_id: accountId, loan_id: match?.params?.id})
        if(res?.status !== 200){
            toast.error(res.message);
        } else {
            if(accountType === 'primary'){
                setPrimaryName(res?.data)
            } else {
                setcoApplicantName(res?.data)
            }
            setTimeout(() => {
                window.location.reload();
            }, 1000)
        }

        setIsLoading(false)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
    }
    return (
        <>
            <Layout
                title={"Penny Drop"}
                isLoading={isLoading}
                isGoback={true}
            >
                <div className="container-fluid">
                    <form onSubmit={(e) => handleSubmit(e)}>
                        {loanAccountResponse?.PRIMARY?.account_number &&
                            <div className="panel-card">
                                <div className="panel-heading">
                                    Primary Account Details
                                </div>
                                <div className="panel-body">
                                    <div className="details-listing">
                                        <div className="row">
                                            <div className="col-6">
                                                <DivLayout
                                                    heading={"Account No"}
                                                    data={
                                                        loanAccountResponse?.PRIMARY?.account_number
                                                    }
                                                />
                                            </div>
                                            <div className="col-6">
                                                <DivLayout
                                                    heading={"IFSC Code"}
                                                    data={
                                                        loanAccountResponse?.PRIMARY?.ifsc_code
                                                    }
                                                />
                                            </div>
                                            <div className="col-6">
                                                <DivLayout
                                                    heading={"Bank Name"}
                                                    data={
                                                        loanAccountResponse?.PRIMARY?.bank_name
                                                    }
                                                />
                                            </div>
                                            <div className="col-6">
                                                <DivLayout
                                                    heading={"Branch Name"}
                                                    data={
                                                        loanAccountResponse?.PRIMARY?.branch_name
                                                    }
                                                />
                                            </div>
                                            <div className="col-6">
                                                <DivLayout
                                                    heading={"Name"}
                                                    data={
                                                        primary?.name
                                                    }
                                                />
                                            </div>
                                            <div className="col-6">
                                                <DivLayout
                                                    heading={"Status"}
                                                    data={
                                                        loanAccountResponse?.PRIMARY?.status
                                                    }
                                                />
                                            </div>
                                            <div className="col-6">
                                                <DivLayout
                                                    heading={"Bank Account Name"}
                                                    data={
                                                        primary?.bank_account_name ? primary?.bank_account_name : loanAccountResponse?.PRIMARY?.account_name
                                                    }
                                                />
                                            </div>
                                            {loanAccountResponse?.PRIMARY?.status !== 'VERIFIED' &&
                                                <div className="col-md-6 d-flex mb-3" style={{justifyContent: "flex-end"}}> 
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        onClick={(e) => {
                                                            handlePennyDrop(e, loanAccountResponse?.PRIMARY?.account_id, 'primary')
                                                        }}
                                                    >
                                                        Penny Drop
                                                    </button>
                                                </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {loanAccountResponse?.CO_APPLICANT?.account_number &&
                            <div className="panel-card">
                                <div className="panel-heading">
                                    Co Applicant Account Details
                                </div>
                                <div className="panel-body">
                                <div className="details-listing">
                                    <div className="row">
                                        <div className="col-6">
                                            <DivLayout
                                                heading={"Account No"}
                                                data={
                                                    loanAccountResponse?.CO_APPLICANT?.account_number
                                                }
                                            />
                                        </div>
                                        <div className="col-6">
                                            <DivLayout
                                                heading={"IFSC Code"}
                                                data={
                                                    loanAccountResponse?.CO_APPLICANT?.ifsc_code
                                                }
                                            />
                                        </div>
                                        <div className="col-6">
                                            <DivLayout
                                                heading={"Bank Name"}
                                                data={
                                                    loanAccountResponse?.CO_APPLICANT?.bank_name
                                                }
                                            />
                                        </div>
                                        <div className="col-6">
                                            <DivLayout
                                                heading={"Branch Name"}
                                                data={
                                                    loanAccountResponse?.CO_APPLICANT?.branch_name
                                                }
                                            />
                                        </div>
                                        <div className="col-6">
                                            <DivLayout
                                                heading={"Status"}
                                                data={
                                                    loanAccountResponse?.CO_APPLICANT?.status
                                                }
                                            />
                                        </div>
                                        <div className="col-6">
                                            <DivLayout
                                                heading={"Name"}
                                                data={
                                                    coApplicant?.name
                                                }
                                            />
                                        </div>
                                        <div className="col-6">
                                            <DivLayout
                                                heading={"Bank Account Name"}
                                                data={
                                                    coApplicant?.bank_account_name ? coApplicant?.bank_account_name : loanAccountResponse?.CO_APPLICANT?.account_name
                                                }
                                            />
                                        </div>
                                        {loanAccountResponse?.CO_APPLICANT?.status !== 'VERIFIED' &&
                                            <div className="col-md-6 d-flex mb-3" style={{justifyContent: "flex-end"}}>
                                                <button
                                                    className="btn btn-primary btn-sm"
                                                    onClick={(e) => {
                                                        handlePennyDrop(e, loanAccountResponse?.CO_APPLICANT?.account_id, 'co_applicant')
                                                    }}
                                                >
                                                    Penny Drop
                                                </button>
                                            </div>
                                        }

                                    </div>
                                </div>
                                </div>
                            </div>
                        }

                    </form>

                </div>

            </Layout>
        </>
    );
};

export default PennyDropAccount;
